import { useCallback } from "react";
const useTreeExpansion = (storage, tree, onNodeExpand, bumpRender)=>{
    const getExpandedState = useCallback(()=>storage.getItem("expandNodes") || {}, [
        storage
    ]);
    const getExpandedNodes = useCallback((expandedState = getExpandedState())=>(tree || []).filter(({ id, childNodes })=>{
            if (!childNodes?.length) {
                return false;
            }
            return expandedState[String(id)] === undefined ? true : expandedState[String(id)];
        }), [
        getExpandedState,
        tree
    ]);
    const handleNodeExpand = useCallback((expanded, node)=>{
        node.id !== undefined && storage.setItem(`expandNodes.${node.id}`, expanded);
        onNodeExpand?.(expanded, node);
        bumpRender();
    }, [
        bumpRender,
        onNodeExpand,
        storage
    ]);
    const handleToggleAll = useCallback(()=>{
        const expanded = getExpandedNodes();
        const newExpandedNodes = {};
        const newState = !expanded.length;
        const walk = ({ id, childNodes = [] })=>{
            if (childNodes.length) {
                newExpandedNodes[String(id)] = newState;
                childNodes.forEach(walk);
            }
        };
        tree.forEach(walk);
        storage.setItem("expandNodes", newExpandedNodes);
        bumpRender();
    }, [
        bumpRender,
        getExpandedNodes,
        storage,
        tree
    ]);
    return {
        getExpandedState,
        getExpandedNodes,
        handleNodeExpand,
        handleToggleAll
    };
};
export { useTreeExpansion };
